import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, useOutletContext } from "react-router-dom";
import { get_list_of_users, get_simulation_detail_summary, get_best_attempt } from '../services/api';
import { rootRoute } from "../../../config";
import { errorMsg,instruMsg } from "../../../helper/helpers";
import { motion } from "framer-motion";
import warning_decision from '../assets/warning_decision.png';
import task_indicator_achieved from '../assets/task_indicator_achieved.png';
import task_indicator_notachieved from '../assets/task_indicator_notachieved.png';
import Button from '../../common/Button'
import ScmModuleStyle from '../styles/scm.module.css';

const InstructorReview = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const [listOfUsers, setListOfUsers] = useState([]);
    const [simulationDetailSummary, setSimulationDetailSummary] = useState([]);
    const [selectedSessionid, setSelectedSessionid] = useState("");
    const [instructorPageHeight, setInstructorPageHeight] = useState("");
    const [simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, isPopupShown, setIsPopupShown, accordionPopup, setAccordionPopup, simObj, setSimObj, getMonth, toggleSimulation, setToggleSimulation, startOverSimulation, isLoader, setIsLoader, setAriaProperty, check_Location, setError] = useOutletContext();

    let session_id = queryParams.get("sid");
    let resource_id = queryParams.get("resid");
    let course_id = queryParams.get("cid");
    let user_id = queryParams.get("userid");

    const checkNum = (num, factor) => {
        return num < 0
           ? `-$${Math?.abs(num)?.toLocaleString(undefined, {
              minimumFractionDigits: factor,
              maximumFractionDigits: factor,
           })}`
           : `$${num?.toLocaleString(undefined, {
              minimumFractionDigits: factor,
              maximumFractionDigits: factor,
           })}`;
     };

     const formatNum = (num) => {
        return num?.toLocaleString("en-US", { style: "decimal" });
      };

    const getListOfUsers = () => {
        (session_id != undefined || session_id != undefined) && get_list_of_users(session_id, resource_id, course_id).then(
            (response) => { 
                if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
                    setError(response?.data)
                }
                else{
                setListOfUsers(response?.data);
                response?.data.map((usr,index)=>{
                    // if(index == 0 && user_id == undefined){                       
                    //     setSelectedSessionid(usr.sessionid);
                    //     triggerChangeEvent(usr.sessionid);
                    // }else if(index == 0){ 
                    //     setSelectedSessionid(user_id);
                    //     getSimulationDetailSummary();
                    // }
                    if(user_id == undefined){                       
                        setSelectedSessionid(response?.data?.[0]?.sessionid);
                        triggerChangeEvent(response?.data?.[0]?.sessionid);
                    }else{ 
                        let session = response?.data?.find(user => user.xluserid == user_id)?.sessionid
                        if(session){
                            setSelectedSessionid(session);
                        }
                        else{
                            setSelectedSessionid(response?.data?.[0]?.sessionid); 
                        }
                    }
                }) 
            }
        }
        ).catch((error) => { 
            // setError(error.status == 404 ? instruMsg : errorMsg);
            setError({"id":"00000","msg":error.status == 404 ? instruMsg : errorMsg})
            console.log(error);
        })
    };
    const triggerChangeEvent = (newValue) => {
        // Create a new input event
        const inputElement = document.querySelector('select');
        const event = new Event('change', { bubbles: true });
        
        // Set the new value as the input's value
        Object.defineProperty(event, 'target', {
          writable: false,
          value: { value: newValue },
        });
      
        // Dispatch the event
        inputElement.dispatchEvent(event);
    };
    const getSimulationDetailSummary = () => {  
       ((simObj?.sessionid != undefined || session_id != undefined) && selectedSessionid != "" && selectedSessionid != null) && get_simulation_detail_summary(session_id, selectedSessionid).then(
            (response) => {
                if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
                    setError(response?.data)
                }
                else{
                setSimulationDetailSummary(response?.data);
                setSimObj((prevObj) => ({
                    ...prevObj,
                    simulationdetails: response?.data
                }));
                setIsLoader(false);
                setIsOverlay(false);  
                }  
            }
        ).catch((error) => {
            // setError(errorMsg);
            setError({"id":"00000","msg":errorMsg})
            console.log(error);
        })
    };
    const getDate = (date) => {
        let dateObject = new Date(date * 1000);
        let options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true };
        if (navigator.userAgent.indexOf('iPhone') > -1) {
            dateObject = new Date(date.replace(/-/g, "/"));
        }
        return dateObject.toLocaleString(navigator.language, options);
    }
    const goToSummary = (e) => {
        setIsLoader(true);
        // let attempt = window.$(e.target).closest("td").find(`.${ScmModuleStyle['button-wrapper']}`).attr("attempt");
        let attempt = window.$(e.target).closest("td").find(">div").attr("attempt");
        queryParams.set("userid", selectedSessionid);
        queryParams.set("attempt", attempt);
        ((queryParams.toString().indexOf("&userid=") != -1) && (queryParams.toString().indexOf("&attempt=") != -1)) ? navigate(`${rootRoute}/scm/summary?${queryParams}`) : navigate(`${rootRoute}/scm/summary?${queryParams}&userid=${selectedSessionid}&attempt=${attempt}`)    
    } 
    const goToDecisionHistory = (e) => {
        setIsLoader(true);
        // let attempt = window.$(e.target).closest("td").find(`.${ScmModuleStyle['button-wrapper']}`).attr("attempt");
        let attempt = window.$(e.target).closest("td").find(">div").attr("attempt");
        queryParams.set("userid", selectedSessionid);
        queryParams.set("attempt", attempt);
        ((queryParams.toString().indexOf("&userid=") != -1) && (queryParams.toString().indexOf("&attempt=") != -1)) ? navigate(`${rootRoute}/scm/decisionhistory?${queryParams}`) : navigate(`${rootRoute}/scm/decisionhistory?${queryParams}&userid=${selectedSessionid}&attempt=${attempt}`)
    }
    const convertToCSV = (bestAttemptArr,formatType) => {
        const separator = ','; // CSV separator
        const note = "NOTE: All dates are displayed in " + formatType + ".";
        const keys = Object.keys(bestAttemptArr[0]);
        const csvHeader = keys.join(separator); // Create CSV header    
        const csvRows = bestAttemptArr.map((row) =>
            keys.map((key) => row[key]).join(separator)
        ); // Create CSV rows    
        return [csvHeader, ...csvRows,"",note].join('\n'); // Combine header and rows with line breaks
    };
    const exportCSV = (bestAttemptArr,formatType) => {
        const csvData = convertToCSV(bestAttemptArr,formatType);
        const blob = new Blob([csvData], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.setAttribute('href', url);
        a.setAttribute('download', 'ClassPerformanceData_SCM.csv');
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };
    const exportCSVOfSummary = () => {
        setIsLoader(true);
        (simObj?.sessionid != undefined || session_id != undefined) && get_best_attempt(session_id, resource_id, course_id).then(
            (response) => {
                if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
                    setError(response?.data)
                }
                else{
                // setBestAttempt(response?.data);
                const formatType = new Date().toString().split("(")[1].replace(/\(|\)/g, "");
                console.log(formatType);
                exportCSV(response?.data
                    ?.sort((a, b) =>
                        a.last_name.localeCompare(b.last_name) ||
                    a.first_name.localeCompare(b.first_name) ||
                        a.attempt_no - b.attempt_no
                    )
                    ?.map((gbAttObj) => ({
                        ["LastName"]: `${gbAttObj.last_name}`,
                        ["FirstName"]: `${gbAttObj.first_name}`,
                    ['attempt #']: gbAttObj.attempt_no,
                    [`Time Spent (Minutes)`]: `${Math.max(1, Math.floor((gbAttObj.end_time - gbAttObj.start_time) / 60)).toLocaleString()}`.replace(",", ""),
                    [`Start Date(${formatType})`]: `="${getDate(gbAttObj.start_time).replace(",", "")}"`,
                    [`Completion Date(${formatType})`]: `="${getDate(gbAttObj.end_time).replace(",", "")}"`,
                    ['Score']: gbAttObj.score,
                    ['Remaining Budget value']: gbAttObj.profit,
                    ['Final Products Manufactured']:gbAttObj.gizmoscompleted,
                    ['Best Attempt (Y/N)']: gbAttObj.best_attempt == "Yes" ? "Y" : "N"
                })),formatType)
            }
            }
        ).catch((error) => {
            // setError(errorMsg);
            setError({"id":"00000","msg":errorMsg})
            console.log(error);
        })
        .finally(() => {
            setTimeout(() => setIsLoader(false), 500);
        })
    }
    useEffect(()=>{console.log(simObj)},[simObj])
    //useEffect(()=>{exportCSV()},[bestAttempt])
    useEffect(() => { 
        if(selectedSessionid != ""){
            setIsLoader(true);
            getSimulationDetailSummary(); 
        }
    }, [selectedSessionid])
    useEffect(() => {
        document.querySelector("header.header").style.display = "none";
        //document.querySelector(`.${ScmModuleStyle['instructorreview-container']} header.header h1`).tabIndex = -1;
        //document.getElementsByClassName(`${ScmModuleStyle['instructorreview-container']}`)[0].querySelector(`header.header h1`).tabIndex = -1;
        // setSelectedSessionid(user_id);
        getListOfUsers();
        // if (document.querySelector("footer.footer .footer-nav .footer-links") != null) {
        //     document.querySelector("footer.footer .footer-nav .footer-links").style.display = "none";
        //  }
        // if (document.querySelector("footer.footer .container") != null) {
        //     document.querySelector("footer.footer .container").style.justifyContent = "center";
        // }
        if (document.querySelector("footer.footer .footer-nav .footer-links") != null) {
            document.querySelector("footer.footer .footer-nav .footer-links").firstChild.style.display = "none";
        }
    document.title = "Supply Chain Management | Instructor Review";
        return () => { 
            if (document.getElementById("instructorreviewContainer") != undefined) {
                document.getElementById("instructorreviewContainer").childNodes[0].style.display = "block";
            }

            if (document.querySelector("footer.footer .footer-nav .footer-links") != null) {
                document.querySelector("footer.footer .footer-nav .footer-links").style.display = "block";
            }
             if (document.querySelector("footer.footer .container") != null) {
                document.querySelector("footer.footer .container").style.justifyContent = "space-between";
            }
        };
    }, [simObj?.sessionid])
    useEffect(()=>{
        // setSelectedSessionid(user_id);
        document.querySelector(".App .row").style.minHeight = "auto";
        const headerHeight = window.$(window.$(window.$(`.app div:first`)[0]).find(".header")[0]).outerHeight(true);
        const footerHeight = window.$(window.$(`footer.footer`)[0]).outerHeight(true);
        const instructorReviewPageHeight = window.$(window).height() - headerHeight - footerHeight; setInstructorPageHeight(instructorReviewPageHeight);
        return () => {
            document.querySelector(".App .row").style.minHeight = "100vh";
        }
    },[])

    return (
        <motion.div id="instructorreviewContainer" className={`${ScmModuleStyle['instructorreview-container']}`} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} >
            <header className={`header ${ScmModuleStyle.header}`}>
                <div className={`container ${ScmModuleStyle.container}`}>
                    <h1>Supply Chain Management Simulation</h1>
                    <div className={`${ScmModuleStyle['btn-dropdown-container']}`}>
                        <Button clickEventHandler={exportCSVOfSummary} btnClass={"ui button export-summary"} btnName={"Export Class Summary"} />
                        <select value={selectedSessionid || ""} className={`ui dropdown ${ScmModuleStyle.ui} ${ScmModuleStyle.dropdown}`} onChange={(e) => setSelectedSessionid(e.target.value)}>
                            {
                                listOfUsers?.sort((a, b) => ((b.name> a.name) ? -1 : 1))?.map((user,index) => (
                                    <option key={index+"_05"} value={user.sessionid}>{user.name}</option>
                                ))
                            }
                        </select>
                    </div>
                </div>
            </header>
            <div className={`${ScmModuleStyle['instructor-table']} ${ScmModuleStyle['instruct-tbl']}`} style={{ height: instructorPageHeight + "px" }}>
                <table className={`ui unstackable table ${ScmModuleStyle.ui} ${ScmModuleStyle.unstackable} ${ScmModuleStyle.table} ${ScmModuleStyle['table-container']}`}>
                    <thead>
                        <tr>
                            <th className={`one wide`}>Attempt #</th>
                            <th className={`two wide`}>Start Date</th>
                            <th className={`two wide`}>Completion Date</th>
                            <th className={`one wide`}>Time Spent (Minutes)</th>
                            <th className={`two wide`}>Remaining Budget ($)</th>
                            <th className={`one wide`}>Final Products Manufactured</th>
                            <th className={`one wide`}>Target Achieved</th>
                            <th className={`two wide`}><span className={`${ScmModuleStyle['text-img-box']}`} data-tooltip="Your best score will be reported to the gradebook" data-position="bottom left">Score<img src={warning_decision} /></span></th>
                            <th className={`four wide`}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            simulationDetailSummary?.map((simDObj, index) => (
                                <tr key={index+"_04"}>
                                    <td>{simDObj?.attemptno}</td>
                                    <td>{getDate(simDObj?.creationtime)}</td>
                                    <td>{getDate(simDObj?.completiontime)}</td>
                                    <td>{`${Math.max(1, Math.floor((simDObj.completiontime - simDObj.creationtime) / 60)).toLocaleString()}`}</td>
                                    <td className={`${ScmModuleStyle['amount-value']}`}>{checkNum(Number(simDObj?.remainingBudget))}</td>
                                    <td className={`${ScmModuleStyle['amount-value']}`}>{formatNum(simDObj?.gizmoManufactured)}</td>
                                    <td><img className={simDObj?.targetcompleted ? 'target_achieved' : 'target_notachieved'} src={simDObj?.targetcompleted ? task_indicator_achieved : task_indicator_notachieved} /></td>
                                    <td>{simDObj?.score}%</td>
                                    <td>
                                        <div className={`${ScmModuleStyle['button-wrapper']}`} attempt={simDObj?.attemptno}>
                                            <Button btnClass={"ui button summary"} clickEventHandler={goToSummary} btnName={"Summary"} />
                                            <Button btnClass={"ui button decision-history"} clickEventHandler={goToDecisionHistory} btnName={"Decision History"} />
                                        </div>
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>
        </motion.div>
    );
}

export default InstructorReview